class MastonDistributor extends HTMLElement {
  #events;
  #dialog;
  #trigger;

  connectedCallback() {
    this.#events?.abort();
    this.#dialog = this.querySelector('dialog');
    this.#trigger = this.querySelector('button[aria-controls]');
    if (!this.#dialog || !this.#trigger) return;
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    this.#trigger.addEventListener('click', () => {
      this.#dialog.showModal();
      this.#trigger.setAttribute('aria-expanded', 'true');
    }, options);
    this.querySelector('[data-distributor-close]')?.addEventListener('click', () => this.#dialog.close(), options);
    this.#dialog.addEventListener('click', (event) => {
      if (event.target !== this.#dialog) return;
      const rect = this.#dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.#dialog.close();
    }, options);
    this.#dialog.addEventListener('close', () => {
      this.#trigger.setAttribute('aria-expanded', 'false');
      this.#trigger.focus({ preventScroll: true });
    }, options);
  }

  disconnectedCallback() {
    this.#events?.abort();
    this.#dialog?.close();
  }
}

if (!customElements.get('maston-distributor')) {
  customElements.define('maston-distributor', MastonDistributor);
}
